import { withRouter } from 'react-router-dom';
import WithSystem from './../service/WithSystem';
const batchFilter = JSON.parse(window.batchFilter);
class ProgressDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.sliderrange = null;
    window.changeSliderProgressRange = this.changeSliderProgressRange;
    this.box     = React.createRef();
    this.state   = { dropdownToggle: false };
    this.timeOut = null;
  }
  componentDidMount() {
    this.sliderrange = $("#slider-range");
  $(function () {
    $("#slider-range").slider({
    range: true,
    orientation: "horizontal",
    min: 0,
    max: 100,
    values: [ $("#min_price").val(), $("#max_price").val()],
    slide: function (event, ui) {
      if (ui.values[0] == ui.values[1]) {
        return false;
      }
      $("#min_price").val(ui.values[0]);
      $("#max_price").val(ui.values[1]);
      if(typeof window.changeSliderProgressRange == 'function' )
      {
        window.changeSliderProgressRange(ui.values[0],ui.values[1]);
      }
    }
    });
    $("#min_price").val($("#slider-range").slider("values", 0));
    $("#max_price").val($("#slider-range").slider("values", 1));
  });
  }
  componentDidUpdate() {
    if(window.clearProgress = true){
      window.clearProgress = false;
    this.sliderrange = $("#slider-range");
    $(function () {
      $("#slider-range").slider({
        range: true,
        orientation: "horizontal",
        min: 0,
        max: 100,
        values: [$("#min_price").val(), $("#max_price").val()],
        slide: function (event, ui) {
          if (ui.values[0] == ui.values[1]) {
            return false;
          }
          $("#min_price").val(ui.values[0]);
          $("#max_price").val(ui.values[1]);
          if (typeof window.changeSliderProgressRange == 'function') {
            window.changeSliderProgressRange(ui.values[0], ui.values[1]);
          }
        }
      });

      $("#min_price").val($("#slider-range").slider("values", 0));
      $("#max_price").val($("#slider-range").slider("values", 1));
    });
    }
  }
  changeSliderProgressRange =(min_progress_range,max_progress_range)=>{
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout( () => {
      this.props.setGlobalState({ 'minProgressRange': min_progress_range, 'maxProgressRange': max_progress_range, progressstatus: false });
    }, 600);
  }
  changeProgressRange =(e) => {
    var min_progress_range = parseInt(document.getElementById("min_price").value);
    var max_progress_range = parseInt(document.getElementById("max_price").value);
    if (min_progress_range > max_progress_range){
      document.getElementById("max_price").value = min_progress_range;
    }
    if(min_progress_range == max_progress_range){
      max_progress_range = min_progress_range + 100;
      document.getElementById("min_price").value = min_progress_range;
      document.getElementById("max_price").value = max_progress_range;
    }
    this.sliderrange.slider({
    values: [min_progress_range, max_progress_range]
    });
    this.props.setGlobalState({ 'minProgressRange': min_progress_range, 'maxProgressRange': max_progress_range, progressstatus: false });
  }
  SetDropdownToggleVall = () => {
    this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
      document.addEventListener('click', this.handleOutsideClick);
    });
  }
  handleOutsideClick = (event) => {
    if (this.box && !this.box.current.contains(event.target)) {
      this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
        if (this.state.dropdownToggle == true) {
          this.setState({ dropdownToggle: false });
        }
        document.removeEventListener('click', this.handleOutsideClick);
      });
    }
  }
  render() {
    return (    
      <div ref={this.box} onClick={() => this.SetDropdownToggleVall()} className={this.state.dropdownToggle == true ? 'branch-list active' : 'branch-list'}>
        <span className="filter-subtxt">Course Progress</span>
        <div className="report-list-menu" >
          <div className="branch-list-sec">Course Progress</div>
          <div className="list_menu_section courseprogressbar" >
            <ul className="list_menu">
              <div className="price-range-block">
                <span className="filter-subtxt">Course Progress</span>
                <div>
                  <span className="price-min-value"><b>Value 01</b><input type="number" value={(this.props.queryFilter.minProgressRange)?this.props.queryFilter.minProgressRange:0} min={0} max={100} onChange={this.changeProgressRange}  id="min_price" className="price-range-field" /><span className="percent-icon"><svg xmlns="http://www.w3.org/2000/svg" width={11} height={19} viewBox="0 0 11 19">
                  <text id="_" data-name="%" transform="translate(0 15)" fill="#2e3e4e" fontSize={14} fontFamily="Roboto-Light, Roboto" fontWeight={300} letterSpacing="0.024em" opacity="0.3"><tspan x={0} y={0}>%</tspan></text></svg>
                  </span></span>
                  <span className="price-max-value"><b>Value 01</b><input type="number" value={(this.props.queryFilter.maxProgressRange)?this.props.queryFilter.maxProgressRange:100} min={0} max={100}  id="max_price" onChange={this.changeProgressRange}   className="price-range-field" /><span className="percent-icon"><svg xmlns="http://www.w3.org/2000/svg" width={11} height={19} viewBox="0 0 11 19">
                  <text id="_" data-name="%" transform="translate(0 15)" fill="#2e3e4e" fontSize={14} fontFamily="Roboto-Light, Roboto" fontWeight={300} letterSpacing="0.024em" opacity="0.3"><tspan x={0} y={0}>%</tspan></text></svg>
                  </span></span>
                </div>
                <div id="slider-range" className="price-filter-range" name="rangeInput" />
                  <div className="slide-range-txt"><span>Min 0</span><span>Max 100</span></div>
                </div>
              <p><svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><path d="M 24 4 C 12.972066 4 4 12.972074 4 24 C 4 35.027926 12.972066 44 24 44 C 35.027934 44 44 35.027926 44 24 C 44 12.972074 35.027934 4 24 4 z M 24 7 C 33.406615 7 41 14.593391 41 24 C 41 33.406609 33.406615 41 24 41 C 14.593385 41 7 33.406609 7 24 C 7 14.593391 14.593385 7 24 7 z M 24 14 A 2 2 0 0 0 24 18 A 2 2 0 0 0 24 14 z M 23.976562 20.978516 A 1.50015 1.50015 0 0 0 22.5 22.5 L 22.5 33.5 A 1.50015 1.50015 0 1 0 25.5 33.5 L 25.5 22.5 A 1.50015 1.50015 0 0 0 23.976562 20.978516 z"></path></svg> <span>Notes:Selecting and altering the course progress filter will automatically reset the course status filter.</span></p>
            </ul>
         </div>
        </div>
     </div>
    );
  }
}
export default withRouter(WithSystem(ProgressDropDown));
